import { ReactElement, useEffect, useState, useRef, memo, useMemo } from 'react';
import { Upload } from '@/sub-luca-plugin/compatible-components';
import { LoadingOutlined } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { toastInQa } from '@/sub-luca-plugin/utils/qa';
import { handleTokenExample } from '@/sub-luca-plugin/utils/class-example';

interface IProps {
    pictures?: string[];
    maxCount?: number;
    children?: ReactElement;
    accept?: string;
    showUploadList?: boolean;
    onChange?: (urls: string[]) => void;
    beforeUpload?: (file: any) => void;
    customRequest?: (info: any) => void;
}

const UploadPicture = ({
    accept = '.jpg, .jpeg, .png',
    pictures = [],
    children,
    maxCount = 1,
    showUploadList = false,
    onChange,
    beforeUpload,
    customRequest,
}: IProps) => {
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);
    const tokenRef = useRef('');

    const handleChange = (info: any) => {
        setLoading(true);
        const newFileList = info.fileList.map((file: any) => {
            if (file.response) file.url = `https://simg01.gaodunwangxiao.com/${file.response.result}`;
            return file;
        });
        setFileList(newFileList);
        // console.log('newFileList', newFileList);
        if (newFileList.some((item: any) => !item.url)) return;
        onChange?.(pictures.concat(newFileList.map((item: any) => item.url!)).slice(0, 6));
        setLoading(false);
        setFileList([]);
    };

    const newProps = useMemo(() => {
        if (customRequest) return {};
        return {
            action: 'https://apigateway.gaodun.com/base/v1/upload/upload',
            headers: { Authentication: `${tokenRef.current}` },
            onChange: handleChange,
        };
    }, [pictures]);

    const handleadditionalPamras = (file: any) => {
        return {
            file_name: file.name,
            item_name: 'luca',
            file_type: 'file',
        };
    };

    const handleClick = () => {
        if (pictures.length < maxCount) return;
        toastInQa(`最多只能上传${maxCount}张图片`);
    };

    useEffect(() => {
        setFileList(oldFileList => {
            if (oldFileList.length > 0) {
                return oldFileList.filter(item => pictures.includes(item.url || ''));
            }
            return oldFileList;
        });
    }, [pictures]);

    useEffect(() => {
        handleTokenExample.getFronttoken().then(accessToken => {
            tokenRef.current = accessToken;
        });
    }, []);

    return (
        <Upload
            {...newProps}
            accept={accept}
            showUploadList={showUploadList}
            maxCount={maxCount}
            multiple
            fileList={fileList}
            disabled={pictures.length >= maxCount}
            data={handleadditionalPamras}
            beforeUpload={beforeUpload}
            customRequest={customRequest}
        >
            {loading ? <LoadingOutlined /> : <div onClick={handleClick}>{children}</div>}
        </Upload>
    );
};

export default memo(UploadPicture);
